(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image_gallery"] && !Shopify.designMode) return;
  try {
    
const galleryContainers = document.querySelectorAll('.gallery-container');

galleryContainers.forEach(container => {
  const thumbnails = container.querySelectorAll('.thumbnail-container img');
  const mainImage = container.querySelector('.main-image img');

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      mainImage.src = thumbnail.dataset.fullsize;
    mainImage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sacpig-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setPaused(button, shouldPause) {
      var root = button.closest('.sacpig-hero-slider');
      var track = root && root.querySelector('.sacpig-hero-slider__track');
      var carousel = window.jQuery && track ? window.jQuery(track) : null;

      button.setAttribute('aria-pressed', shouldPause ? 'true' : 'false');
      button.setAttribute('aria-label', shouldPause ? 'Resume slideshow' : 'Pause slideshow');

      if (!track) return;

      track.setAttribute('data-autoplay', shouldPause ? 'false' : 'true');
      if (carousel && carousel.hasClass('slick-initialized')) {
        carousel.slick(shouldPause ? 'slickPause' : 'slickPlay');
      }
    }

    function initialize(root) {
      if (!root || root.dataset.sacpigHeroReady === 'true') return;

      root.dataset.sacpigHeroReady = 'true';
      var button = root.querySelector('[data-sacpig-hero-pause]');
      var track = root.querySelector('.sacpig-hero-slider__track');
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (button) {
        button.addEventListener('click', function () {
          setPaused(button, button.getAttribute('aria-pressed') !== 'true');
        });
      }

      if (button && track && prefersReducedMotion) {
        track.setAttribute('data-autoplay', 'false');
        setPaused(button, true);

        if (window.jQuery) {
          window.jQuery(track).one('init.sacpigHero', function () {
            setPaused(button, true);
          });
        }
      }
    }

    function initializeAll(scope) {
      var roots = scope.querySelectorAll
        ? scope.querySelectorAll('.sacpig-hero-slider')
        : [];

      Array.prototype.forEach.call(roots, initialize);
      if (scope.matches && scope.matches('.sacpig-hero-slider')) initialize(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
